import angular from 'angular';
import { IRule } from './rule.interface';
import { ModelerValidation } from './@types/services';
import { Services } from '@Shared.Angular/@types/services';
import IModelerNode from '@Shared.Angular/@types/modelerNode';
import ActivityTaskType from '@Shared.Angular/@types/core/contracts/queryModel/workflow/steps/activityTaskType';
import DynamicActorTypes from '@Shared.Angular/@types/core/contracts/queryModel/node/dynamicActorTypes';

export class RulesetParserService {
  constructor(
    private ruleService: ModelerValidation.RuleService,
    private flowinglyConstants: Services.FlowinglyConstants
  ) {}

  divergeParser(firstNodesOfDivergedPaths: IModelerNode[]) {
    const matchRules: IRule[] = [this.ruleService.DEFAULT];
    const dynamicActorCount = firstNodesOfDivergedPaths.filter(
      (node) =>
        node.taskType === ActivityTaskType.TASK &&
        node.dynamicActorType === DynamicActorTypes.SelectDynamicActors
    ).length;
    const dynamicActorARCount = firstNodesOfDivergedPaths.filter(
      (node) =>
        node.taskType === ActivityTaskType.APPROVAL &&
        node.dynamicActorType === DynamicActorTypes.SelectDynamicActors
    ).length;
    const parallelARCount = firstNodesOfDivergedPaths.filter(
      (node) => node.taskType === ActivityTaskType.PARALLEL_APPROVAL
    ).length;
    const sequentialARCount = firstNodesOfDivergedPaths.filter(
      (node) => node.taskType === ActivityTaskType.SEQUENTIAL_APPROVAL
    ).length;

    if (dynamicActorCount >= 2) {
      matchRules.push(this.ruleService.DYNAMICACTOR_DYNAMICACTOR);
    }

    if (dynamicActorARCount >= 2) {
      matchRules.push(this.ruleService.DYNAMICACTORAR_DYNAMICACTORAR);
    }

    if (dynamicActorCount > 0 && parallelARCount > 0) {
      matchRules.push(this.ruleService.DYNAMICACTOR_PARALLELAPPROVAL);
    }

    if (dynamicActorARCount > 0 && parallelARCount > 0) {
      matchRules.push(this.ruleService.DYNAMICACTORAR_PARALLELAPPROVAL);
    }

    if (dynamicActorCount > 0 && sequentialARCount > 0) {
      matchRules.push(this.ruleService.DYNAMICACTOR_SEQUENTIALAPPROVAL);
    }

    if (dynamicActorARCount > 0 && sequentialARCount > 0) {
      matchRules.push(this.ruleService.DYNAMICACTORAR_SEQUENTIALAPPROVAL);
    }

    if (sequentialARCount >= 2) {
      matchRules.push(this.ruleService.SEQUENTIALAPPROVAL_SEQUENTIALAPPROVAL);
    }

    if (parallelARCount >= 2) {
      matchRules.push(this.ruleService.PARALLELAPPROVAL_PARALLELAPPROVAL);
    }

    if (sequentialARCount > 0 && parallelARCount > 0) {
      matchRules.push(this.ruleService.PARALLELAPPROVAL_SEQUENTIALAPPROVAL);
    }

    return matchRules;
  }

  convergeParser(nodes: IModelerNode[]): [IRule] {
    const matchRules: [IRule] = [this.ruleService.DEFAULT];

    const exclusiveGatewayCount = nodes.filter(
      (n) =>
        n.category === this.flowinglyConstants.nodeCategory.EXCLUSIVE_GATEWAY
    ).length;

    if (exclusiveGatewayCount > 0) {
      matchRules.push(this.ruleService.EXCLUSIVEGATEWAY_CONVERGEGATEWAY);
    }

    return matchRules;
  }
}

angular
  .module('flowingly.modeler.validation')
  .factory('rulesetParserService', [
    'ruleService',
    'flowinglyConstants',
    (ruleService, flowinglyConstants) =>
      new RulesetParserService(ruleService, flowinglyConstants)
  ]);

export type RulesetParserServiceType = InstanceType<
  typeof RulesetParserService
>;
